import { useMemo } from "react";
import type { TaktBoardResponse } from "../../../models";

export function useActivityLookups(data: TaktBoardResponse | null) {
  return useMemo(() => {
    const workCodeMap = new Map<number, string>();
    const sectionMap = new Map<number, string>();
    const zoneMap = new Map<number, string>();

    if (!data) return { workCodeMap, sectionMap, zoneMap };

    for (const section of data.sections) {
      for (const group of section.groups) {
        for (const entry of group.entries) {
          for (const aid of entry.activity_ids) {
            workCodeMap.set(aid, entry.work_code);
            sectionMap.set(aid, section.name);
            zoneMap.set(aid, group.name);
          }
        }
      }
    }
    return { workCodeMap, sectionMap, zoneMap };
  }, [data]);
}
